module.exports = __webpack_public_path__ + "static/img/16.967168c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/16.png
// module id = qdv7
// module chunks = 0